<template>
	<BaseCmsLabel tag="h2" class="login-title" :class="[mode]" code="login" v-if="mode != 'checkout'" />

	<AuthSocialLogin :mode="mode" v-if="mode != 'checkout'" />

	<BaseAuthLoginForm class="wc-login-form step1 ajax_siteform form-animated-label" v-slot="{fields, formError}" :submit-url="mode == 'checkout' ? 'webshop_customer' : 'auth'">
		<div class="global_error global-error" v-if="formError">
			<BaseCmsLabel :code="formError" />
		</div>

		<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage, floatingLabel}">
			<p class="field" :class="['field-' + item.name, {'ffl-floated': floatingLabel}]">
				<template v-if="item.name == 'remember_me'">
					<BaseFormInput :id="item.name" />
					<BaseCmsLabel tag="label" :for="item.name" :code="'remember'" />
				</template>
				<template v-else>
					<BaseCmsLabel tag="label" :for="item.name" :code="item.name" />
					<BaseFormInput :id="item.name" />
				</template>
				<span class="field_error error" v-show="errorMessage" v-html="errorMessage" />
			</p>
		</BaseFormField>
		
		<BaseAuthUser v-slot="{urls}">
			<div class="lr-btn-pw">
				<button type="submit" class="btn btn-primary" :class="mode"><BaseCmsLabel code="login2" tag="span" /></button>
				<div class="auth-links" :class="mode">
					<NuxtLink :to="urls.auth_forgotten_password" data-auth_login="forgotten_password" data-siteform_response="show_hide" data-siteform_response_hide="-1">
						<BaseCmsLabel code="forgotten_password" tag="div" />
					</NuxtLink>
				</div>
			</div>
		</BaseAuthUser>
	</BaseAuthLoginForm>
</template>

<script setup>
	const props = defineProps(['mode']);
</script>

<style lang="less" scoped>
	//checkout
	.login-title.checkout{}
	.btn-primary.checkout{color: white; margin: 0; width: auto; min-width: 160px !important; width: 160px !important;}
	.auth-links.checkout{
		:deep(a){
			color: var(--textColor); font-weight: 300;
			span{font-weight: bold !important; color: var(--primaryColor) !important; text-underline-offset: 2px;}
			@media(min-width: @h){
				&:hover{
					span{text-decoration: none;}
				}
			}
		}
	}
</style>

<style lang="less">
	.wc-login-form{display: block !important;}
</style>